export default {
  outOfStock: {
    id: 'price_guide_best_offers_table_cell_out_of_stock',
    defaultMessage: 'Out of stock',
  },
} as const
